const formControlLabelCalendar = {
  checkActions: 'Ações',
  checkServices: 'Serviços Realizados',
  checkFutureServices: 'Serviços Futuros',
  checkMaintenances: 'Manutenções',
  checkServicesReplicated: 'Serviços A Realizar / Vencidos',
};

export default formControlLabelCalendar;
